<template>
	<Popup
		v-model="selfDisplay"
		title="查看治疗仪"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label">机器ID</span>
				<el-input :value="mid" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">生产日期</span>
				<el-date-picker
					:value="createDate"
					disabled
					:editable="false"
					type="date"
					value-format="yyyy-MM-dd"
				>
				</el-date-picker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">生产批号</span>
				<el-input :value="createNumber" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">型号</span>
				<el-input :value="model" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">芯片ID</span>
				<el-input :value="chipId" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">版本</span>
				<el-input :value="version" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">出售日期</span>
				<el-date-picker
					:value="sellDate"
					disabled
					:editable="false"
					type="date"
					value-format="yyyy-MM-dd"
				>
				</el-date-picker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">省市区</span>
				<VDistpicker :province="provinceName" :city="cityName" :area="areaName" disabled></VDistpicker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">所属机构</span>
				<el-input :value="oname" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">剩余用量</span>
				<el-input :value="remain" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">计费方式</span>
				<el-select :value="billing" disabled style="width: 100%;">
					<el-option :value="1" label="无限"></el-option>
					<el-option :value="2" label="包月"></el-option>
					<el-option :value="3" label="计次"></el-option>
					<el-option :value="4" label="计时"></el-option>
				</el-select>
				<div v-if="billing == 2" style="margin-top: 20px;line-height: 36px;">
					开始时间
					<el-date-picker
						:value="billingStartDate"
						disabled
						:editable="false"
						type="date"
						value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				</div>
				<div v-if="billing == 2" style="margin-top: 20px;line-height: 36px;">
					结束时间
					<el-date-picker
						:value="billingEndDate"
						disabled
						:editable="false"
						type="date"
						value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				</div>
				<div v-if="billing == 3" style="margin-top: 20px;line-height: 36px;">
					<el-input :value="billingNum" disabled style="width: 200px;"></el-input>
					次
				</div>
				<div v-if="billing == 4" style="margin-top: 20px;line-height: 36px;">
					<el-input :value="billingMinute" disabled style="width: 200px;"></el-input>
					分钟
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: Number,
				default: -1
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				mid: '',
				createDate: '',
				createNumber: '',
				model: '',
				chipId: '',
				version: '',
				sellDate: '',
				provinceName: '',
				cityName: '',
				areaName: '',
				oname: '',
				remain: '',
				billing: 1,
				billingStartDate: '',
				billingEndDate: '',
				billingNum: '',
				billingMinute: ''
			}
		},
		methods: {
			// 获取详情数据
			getData() {
				const that = this;
				that.loading = true;
				Api.getIFDetail(that.id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.mid = res.data.data.machineId;
						that.createDate = res.data.data.productionDate;
						that.createNumber = res.data.data.productionSerial;
						that.model = res.data.data.modelName;
						that.chipId = res.data.data.chipId;
						that.version = res.data.data.swVersion;
						that.sellDate = res.data.data.saleDate;
						that.provinceName = res.data.data.provinceName;
						that.cityName = res.data.data.cityName;
						that.areaName = res.data.data.areaName;
						that.oname = res.data.data.enterpriseName;
						that.remain = res.data.data.remainInfo;
						that.billing = res.data.data.feeType;
						that.billingStartDate = res.data.data.monthStartTime || '';
						that.billingEndDate = res.data.data.monthEndTime || '';
						that.billingNum = res.data.data.timeCount || '';
						that.billingMinute = res.data.data.minuteCount || '';
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getData();
				} else {
					this.loading = false;
					this.mid = '';
					this.createDate = '';
					this.createNumber = '';
					this.model = '';
					this.chipId = '';
					this.version = '';
					this.sellDate = '';
					this.provinceName = '';
					this.cityName = '';
					this.areaName = '';
					this.oname = '';
					this.remain = '';
					this.billing = 1;
					this.billingStartDate = '';
					this.billingEndDate = '';
					this.billingNum = '';
					this.billingMinute = '';
				}
			}
		}
	}
</script>

<style>
</style>
